import { render, staticRenderFns } from "./feedbackRecords.vue?vue&type=template&id=488fe9dd&scoped=true"
import script from "./feedbackRecords.vue?vue&type=script&lang=js"
export * from "./feedbackRecords.vue?vue&type=script&lang=js"
import style0 from "./feedbackRecords.vue?vue&type=style&index=0&id=488fe9dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488fe9dd",
  null
  
)

export default component.exports